import React from "react";

const NoticeBellIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_26549_11814)">
        <path
          d="M27.3743 23.442L27.091 23.192C26.2872 22.4758 25.5836 21.6545 24.9993 20.7503C24.3612 19.5024 23.9787 18.1397 23.8743 16.742V12.6253C23.8799 10.43 23.0835 8.30822 21.635 6.65864C20.1864 5.00905 18.1853 3.94521 16.0077 3.66699V2.59199C16.0077 2.29694 15.8905 2.01397 15.6818 1.80534C15.4732 1.5967 15.1902 1.47949 14.8952 1.47949C14.6001 1.47949 14.3172 1.5967 14.1085 1.80534C13.8999 2.01397 13.7827 2.29694 13.7827 2.59199V3.68366C11.6246 3.98193 9.64766 5.05221 8.21812 6.69625C6.78859 8.34029 6.00329 10.4467 6.00768 12.6253V16.742C5.90331 18.1397 5.52083 19.5024 4.88268 20.7503C4.30842 21.6523 3.61618 22.4734 2.82435 23.192L2.54102 23.442V25.792H27.3743V23.442Z"
          fill={fill}
        />
        <path
          d="M12.7656 26.667C12.8387 27.1952 13.1005 27.6792 13.5025 28.0295C13.9046 28.3797 14.4199 28.5727 14.9531 28.5727C15.4864 28.5727 16.0016 28.3797 16.4037 28.0295C16.8058 27.6792 17.0675 27.1952 17.1406 26.667H12.7656Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_26549_11814">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

NoticeBellIcon.defaultProps = {
  width: 30,
  height: 30,
  fill: "#333333",
};

export default NoticeBellIcon;
